import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from './pages/common/NotFound';
import Login from './pages/common/Login';
import App from './App';
import UnsubscribePage from './pages/mail/UnsubscribePage';

export default () => (
    <Router>
        <Switch>
            <Route exact path="/">
                <Redirect to="/app/dashboard/index" />
            </Route>
            <Route path="/app" component={App} />
            <Route path="/404" component={NotFound} />
            <Route path="/login" component={Login} />
            <Route exact path="/mail/unsubscribe/:token" component={UnsubscribePage} />
            <Route component={NotFound} />
        </Switch>
    </Router>
);
